import React, { useState } from 'react';
import { isChrome, getBrowserName } from './browserDetection';
import './BrowserWarning.css';

const BrowserWarning = () => {
  const [isVisible, setIsVisible] = useState(!isChrome());

  if (!isVisible) {
    return null;
  }

  const currentBrowser = getBrowserName();

  return (
    <div className="browser-warning">
      <div className="browser-warning-content">
        <div className="browser-warning-icon">⚠️</div>
        <div className="browser-warning-text">
          <h3>Browser Compatibility Warning</h3>
          <p>
            You are currently using <strong>{currentBrowser}</strong>. 
            For the best experience, we recommend using <strong>Google Chrome</strong>.
          </p>
          <p>
            Some features may not work properly in your current browser.
          </p>
        </div>
        <button 
          className="browser-warning-close"
          onClick={() => setIsVisible(false)}
          aria-label="Close warning"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default BrowserWarning; 